import type { NextPage } from "next";
import Link from "next/link";
import { useRouter } from "next/router";
import { FormEvent, useState } from "react";
import EmployeeForm from "../../components/EmployeeForm";
import Layout from "../../components/Layout";
import useStore from "../../store/store";
import { IEmployee } from "../../types/employee";
import { printObject } from "../../utils";
import { emailAddress, emailTemplates, routes } from "../../utils/constants";
import { UploadIcon } from "@heroicons/react/outline";

export const emptyForm: IEmployee = {
  dateOfregistration: "",
  _id: "",
  firstName: "",
  lastName: "",
  registerNumber: "",
  dateOfBirth: "",
  birthCity: "",
  sex: "",
  birthCountry: "",
  nationality: "default",
  street: "",
  number: "",
  bus: "",
  zip: "",
  city: "",
  country: "default",
  language: "default",
  phone: "",
  email: "",
  cevilRegistery: "default",
  bic: "",
  dependentSpouse: "default",
  dependentChildren: "0",
  bankAccountNumber: "",
  status: "default",
  permanentEmployee: false,
  paymentInfo: "",
};

const RegisterEmployeePage: NextPage = () => {
  const { addEmployee, sendEmail, myCompany, username , setLoading} = useStore();

  const [formData, setFormData] = useState<IEmployee>(emptyForm);

  const router = useRouter();

  const sendForm = async (e: FormEvent) => {
    e.preventDefault();
    setLoading(true)
    if (formData.permanentEmployee) {
      addEmployee(formData);
      setFormData(emptyForm);

      router.push(routes.employees);
    } else {
      const companyName = myCompany?.includes("#")
        ? myCompany.split("#")[1]
        : myCompany;
      const emailRes = await sendEmail(
        emailAddress.administratie,
        process.env.NEXT_PUBLIC_newEmployee!,
        {
          subject:
            "Selfservice - Nieuwe werknemer geregistreerd voor " +
            companyName.toString(),
          employeeData: formData,
          registratorName: username,
          companyName: companyName.toString(),
        }
      );

      if (emailRes) {
        addEmployee(formData);
        setFormData(emptyForm);

        router.push(routes.employees);
      }
    }
  };

  return (
    <Layout currentPage="employees">
      <div className="container max-w-7xl mx-auto text-xs">
        <form autoComplete="off" onSubmit={sendForm} className="mx-11">
          <div className="flex justify-between items-center my-8 font-bold">
            <h2 className="text-2xl">Nieuwe medewerker inschrijven</h2>
            <div className="flex">
              <Link href={routes.employeesBulk}>
                <a className="btn-secondary mr-3 flex items-center">
                  <UploadIcon className="mr-1" height={20}></UploadIcon>
                  Bulk uploaden
                </a>
              </Link>

              <button className="p-2.5 flex items-center text-white bg-blue rounded-lg font-bold">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 mx-1"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                </svg>
                Inschrijven
              </button>
            </div>
          </div>

          <EmployeeForm
            formData={formData}
            setFormData={setFormData}
          ></EmployeeForm>
        </form>
      </div>
    </Layout>
  );
};

export default RegisterEmployeePage;
